import { Chip } from "../../components/common/chip";
import type { DocumentDto } from "../../api";
import { DocumentDtoStatusEnum } from "../../api";

export function docStatusChip(status: string) {
  if (status === DocumentDtoStatusEnum.Approved) return <Chip variant="approved">Approved</Chip>;
  if (status === DocumentDtoStatusEnum.Rejected) return <Chip variant="rejected">Rejected</Chip>;
  return <Chip variant="inReview">Pending</Chip>;
}

export function overallStatusChip(documents: DocumentDto[]) {
  const hasPending = documents.some((d) => d.status === DocumentDtoStatusEnum.Pending);
  const hasRejected = documents.some((d) => d.status === DocumentDtoStatusEnum.Rejected);
  if (hasPending) return <Chip variant="inReview">Pending</Chip>;
  if (hasRejected) return <Chip variant="rejected">Rejected</Chip>;
  return <Chip variant="approved">Approved</Chip>;
}

export function formatUploadDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function formatRelativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const minutes = Math.floor(diffMs / (1000 * 60));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
